module.exports = __webpack_public_path__ + "img/four02.6d001838.png";